angular.module('core')
  .directive('sortableTableDropdown', function() {
    return {
      restrict: 'E',
      scope: {
        columns: '='
      },
      templateUrl: '/resources/core/partials/sortable-table-dropdown.html',
      controller: 'SortableTableDropdownController'
    };
  });

angular.module('core').controller('SortableTableDropdownController', ['$scope', '$element', '$timeout', 'tableSort', function($scope, $element, $timeout, $tableSort) {

  $scope.tableSortService = $tableSort;

  $scope.generateOrderIndicator = function(sortType, order) {
    if (sortType === 'text') {
      if (order === 'asc') {
        return 'A-Z';
      } else {
        return 'Z-A';
      }
    }

    if (sortType === 'numeric') {
      if (order === 'asc') {
        return 'Low-High';
      } else {
        return 'High-Low';
      }
    }
  };

  $scope.handleSortOptionClick = function(option) {
    $timeout(function() {
      $element.find('input').blur();
    });
    $tableSort.handleSortOptionClick(option);
  };

  $scope.generateSortOptions = function(columns) {
    var result = [];
    if (!_.isArray(columns) || columns.length === 0) {
      return result;
    }
    _.forEach(columns, function(column) {
      if (typeof column.sortType !== 'undefined') {
        var ascOption = _.pick(column, ['id', 'name', 'sortType']);
        ascOption.order = 'asc';
        ascOption.orderIndicator = $scope.generateOrderIndicator(column.sortType, 'asc');
        var descOption = _.pick(column, ['id', 'name', 'sortType']);
        descOption.order = 'desc';
        descOption.orderIndicator = $scope.generateOrderIndicator(column.sortType, 'desc');
        result.push(ascOption);
        result.push(descOption);
      }
    });

    return result;
  };

  $scope.$watch('columns', function() {

    $scope.sortOptions = $scope.generateSortOptions($scope.columns);
    $scope.selectedSortOption = _.findWhere($scope.sortOptions, {
      id: $tableSort.activeColumnId
    });
  });
}]);
